module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js
// module id = c8Kh
// module chunks = 0